module.exports = __webpack_public_path__ + "static/media/pic-ht18.24464630.jpg";